import { css } from '@fable/theme'
import { useStreakCalendarGrid } from './useStreakCalendarGrid'
import { StreakCalendarCell } from './StreakCalendarCell'
import { StreakCalendarGridHeader } from './StreakCalendarGridHeader'
import { useStreakCell } from './useStreakCell'

export const StreakCalendarGrid = () => {
  const grid = useStreakCalendarGrid()
  const { getStreakCell } = useStreakCell()

  return (
    <div>
      <StreakCalendarGridHeader />
      <div
        className={css`
          width: 100%;
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          grid-auto-rows: 52px;
          gap: 6px;
        `}
      >
        {grid.map((cell, i) => (
          <StreakCalendarCell key={i} {...cell} {...getStreakCell(cell)} />
        ))}
      </div>
    </div>
  )
}
